import { useState, useEffect } from "react"
import {
  TalentProvider,
  useTalent,
  TalentGrid,
  TalentList,
  TalentFilters,
  TalentProfileView,
  TalentSearchBar,
  AddCVButton,
  FilterType
} from "@/components/talent-pool"
import { CardDescription } from "@/components/ui/card"
import { CardTitle } from "@/components/ui/card"

function TalentPoolContent() {
  const {
    filteredTalents,
    viewMode,
    searchQuery,
    filters,
    selectedTalent,
    setViewMode,
    setSearchQuery,
    setFilters,
    resetFilters,
    setSelectedTalent
  } = useTalent()

  const [filterOpen, setFilterOpen] = useState(false)
  const [profileOpen, setProfileOpen] = useState(false)

  const handleViewProfile = (id: string) => {
    setSelectedTalent(id)
    setProfileOpen(true)
  }

  const handleApplyFilters = (newFilters: FilterType) => {
    console.log("Applying filters:", newFilters)
    setFilters(newFilters)
  }

  return (
    <div className="container mx-auto py-6 space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <div>
            <CardTitle className="text-2xl font-bold">Talent Pool</CardTitle>
            <CardDescription>View and manage your private potential candidates</CardDescription>
          </div>
        </div>
        <AddCVButton />
      </div>

      <TalentSearchBar
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onFilterClick={() => setFilterOpen(true)}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
      />

      <TalentFilters
        open={filterOpen}
        onOpenChange={setFilterOpen}
        filters={filters}
        onApplyFilters={handleApplyFilters}
        onResetFilters={resetFilters}
      />

      <div className="pt-4">
        {filteredTalents.length === 0 ? (
          <div className="text-center py-16 text-gray-500">
            <p>No talents found matching your criteria</p>
          </div>
        ) : viewMode === "grid" ? (
          <TalentGrid
            talents={filteredTalents}
            onViewProfile={handleViewProfile}
          />
        ) : (
          <TalentList
            talents={filteredTalents}
            onViewProfile={handleViewProfile}
          />
        )}
      </div>

      <TalentProfileView
        talent={selectedTalent}
        open={profileOpen}
        onOpenChange={setProfileOpen}
      />
    </div>
  )
}

export default function TalentPoolPage() {
  return (
    <TalentProvider>
      <TalentPoolContent />
    </TalentProvider>
  )
} 